import { createBrowserRouter } from "react-router";

import { App } from "@/App";

import { WrongAccess } from "@/pages/WrongAccess";
import { Layout } from "@/Layout/Layout";
import { Login } from "./pages/Login/Login";
// import { CareTransferList } from "./pages/CareTransfer/CareTransferList/CareTransferList";
// import { CareTransferDetail } from "./pages/CareTransfer/CareTransferDetail/CareTransferDetail";
import { CareInsightList } from "./pages/CareInsight/CareInsightList/CareInsightList";
import { CareInsightDetail } from "./pages/CareInsight/CareInsightDetail/CareInsightDetail";
import { Transferring } from "./pages/Transferring/Transferring";
import Popup from "./pages/Popup/Popup";
import { Chatting } from "./pages/Popup/Chatting/Chatting";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <WrongAccess />,
    children: [
      {
        path: "",
        element: <Layout />,
        children: [
          // {
          //   path: "careTransfer",
          //   children: [
          //     {
          //       path: "",
          //       element: <CareTransferList />,
          //     },
          //     {
          //       path: ":id",
          //       element: <CareTransferDetail />,
          //     },
          //   ],
          // },
          {
            path: "careInsight",
            children: [
              {
                path: "",
                element: <CareInsightList />,
              },
              {
                path: ":requestId",
                element: <CareInsightDetail />,
              },
            ],
          },
          { path: "interHospital", element: <div>준비 중입니다.</div> },
          {
            path: "transferring",
            element: <Transferring />,
            children: [
              {
                path: ":requestId",
                element: <Transferring />,
              },
            ],
          },
        ],
      },
      {
        path: "",
        element: <Popup />,
        children: [{ path: "chatting", element: <Chatting /> }],
      },
      {
        path: "login",
        element: <Login />,
      },
    ],
  },
]);

export default router;
